import { render, staticRenderFns } from "./table-column.vue?vue&type=template&id=7cecdfc8&scoped=true"
import script from "./table-column.vue?vue&type=script&lang=ts"
export * from "./table-column.vue?vue&type=script&lang=ts"
import style0 from "./table-column.vue?vue&type=style&index=0&id=7cecdfc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cecdfc8",
  null
  
)

export default component.exports